import {useQuery} from '@tanstack/react-query'
import {ClientInclude} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import getAllClients from './getAllClients'

type Props = {
  selectedCompanies?: number[]
  includes?: ClientInclude[]
  hasPermission?: boolean
}

export default function useClients({selectedCompanies, includes, hasPermission}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    enabled: hasPermission,
    queryKey: [QueryKeyEnum.CLIENTS, selectedCompanies, includes],
    queryFn: async () =>
      await getAllClients({
        filter: {
          companyIds: selectedCompanies,
        },
        includes,
      }),
  })

  return query
}
